export const settingsTranslations = {
  en: {
    language: "Language Preference",
    notifications: "Notification Preferences",
    privacy: "Privacy Settings",
    about: "About",
    terms: "Terms & Conditions",
    select_language: "Select Language",
    language_description: "Select your preferred language for the application interface.",
    current_language: "Current Language",
    language_code: "Language code",
    language_tip: "Language changes are applied immediately to all translated pages.",
    countries: "Countries",
    select_countries: "Select countries",
    regions: "Regions",
    select_regions: "Select regions",
    notification_type: "Notification Type",
    email_notification: "Email Notification",
    push_notification: "Push Notification",
    save_notifications: "Save Notification Settings",
    settings_title: "Settings",
    settings_description: "Manage your account preferences and application settings.",
    under_development: "This section is under development",
    link_account: "Link account",
    link_account_description: "You can link your Stripe account with other services to sync payment data across platforms and manage your transactions.",
    stripe_account: "Stripe account",
    stripe_connected: "Connected",
    stripe_verification_pending: "Verification pending",
    stripe_data_shared: "Data is shared from Stripe to Hoowlr.",
    stripe_review_data: "Visit your Stripe account to review what data is shared with Hoowlr.",
    stripe_privacy_policy: "Stripe Privacy Policy",
    stripe_linked_on: "Linked on {{date}}",
    update_details: "Update details",
    unlink: "Unlink",
    unlink_stripe_title: "Unlink Stripe account?",
    unlink_stripe_description: "You will need to link Stripe again to send or receive payments. Unlinking is not possible while you have an active deal or an active opportunity card.",
    stripe_unlinked: "Stripe account unlinked successfully",
    failed_to_unlink_stripe: "Failed to unlink Stripe account",
    failed_to_open_onboarding: "Failed to open account onboarding",
    validation_failed: "Validation failed",
    missing_profile_setting_id: "Missing profile setting ID",
    language_update_success: "Language updated successfully",
    language_update_failed: "Failed to update language",
    notifications_save_success: "Notification settings saved successfully",
    notifications_save_failed: "Failed to save settings",
    failed_load_countries: "Failed to load countries",
    failed_load_regions: "Failed to load regions",
    at_least_one_country: "At least one country is required",
    at_least_one_region: "At least one region is required",
    card_publish_description: "Triggered when a card is published.",
    deal_propose_description: "Notifies when a deal is proposed.",
    deal_confirm_description: "Notifies when a deal is confirmed.",
    contact_invite_description: "Triggered when someone invites you to connect.",
    contact_accept_description: "Notifies when someone accepts your contact requestirono.",
    activation_required:"Activation Required"
  },
  de: {
    language: "Spracheinstellungen",
    notifications: "Benachrichtigungseinstellungen",
    privacy: "Datenschutzeinstellungen",
    about: "Über",
    terms: "Nutzungsbedingungen",
    select_language: "Sprache auswählen",
    language_description: "Wählen Sie Ihre bevorzugte Sprache für die Benutzeroberfläche aus.",
    current_language: "Aktuelle Sprache",
    language_code: "Sprachcode",
    language_tip: "Sprachänderungen werden sofort auf alle übersetzten Seiten angewendet.",
    countries: "Länder",
    select_countries: "Länder auswählen",
    regions: "Regionen",
    select_regions: "Regionen auswählen",
    notification_type: "Benachrichtigungstyp",
    email_notification: "E-Mail-Benachrichtigung",
    push_notification: "Push-Benachrichtigung",
    save_notifications: "Benachrichtigungseinstellungen speichern",
    settings_title: "Einstellungen",
    settings_description: "Verwalten Sie Ihre Kontoeinstellungen und Anwendungseinstellungen.",
    under_development: "Dieser Abschnitt ist in Entwicklung",
    link_account: "Konto verknüpfen",
    link_account_description: "Sie können Ihr Stripe-Konto mit anderen Diensten verknüpfen, um Zahlungsdaten plattformübergreifend zu synchronisieren und Ihre Transaktionen zu verwalten.",
    stripe_account: "Stripe-Konto",
    stripe_connected: "Verbunden",
    stripe_verification_pending: "Verifizierung ausstehend",
    stripe_data_shared: "Daten werden von Stripe an Hoowlr weitergegeben.",
    stripe_review_data: "Besuchen Sie Ihr Stripe-Konto, um zu prüfen, welche Daten mit Hoowlr geteilt werden.",
    stripe_privacy_policy: "Stripe-Datenschutzrichtlinie",
    stripe_linked_on: "Verknüpft am {{date}}",
    update_details: "Details aktualisieren",
    unlink: "Verknüpfung aufheben",
    unlink_stripe_title: "Stripe-Verknüpfung aufheben?",
    unlink_stripe_description: "Sie müssen Stripe erneut verknüpfen, um Zahlungen zu senden oder zu empfangen. Das Aufheben ist nicht möglich, solange Sie einen aktiven Deal oder eine aktive Opportunity-Karte haben.",
    stripe_unlinked: "Stripe-Verknüpfung wurde aufgehoben",
    failed_to_unlink_stripe: "Stripe-Verknüpfung konnte nicht aufgehoben werden",
    failed_to_open_onboarding: "Onboarding konnte nicht geöffnet werden",
    validation_failed: "Validierung fehlgeschlagen",
    missing_profile_setting_id: "Fehlende Profil-Einstellungs-ID",
    language_update_success: "Sprache erfolgreich aktualisiert",
    language_update_failed: "Sprache konnte nicht aktualisiert werden",
    notifications_save_success: "Benachrichtigungseinstellungen erfolgreich gespeichert",
    notifications_save_failed: "Einstellungen konnten nicht gespeichert werden",
    failed_load_countries: "Länder konnten nicht geladen werden",
    failed_load_regions: "Regionen konnten nicht geladen werden",
    at_least_one_country: "Mindestens ein Land ist erforderlich",
    at_least_one_region: "Mindestens eine Region ist erforderlich",
    card_publish_description: "Wird ausgelöst, wenn eine Karte veröffentlicht wird.",
    deal_propose_description: "Benachrichtigt, wenn ein Deal vorgeschlagen wird.",
    deal_confirm_description: "Benachrichtigt, wenn ein Deal bestätigt wird.",
    contact_invite_description: "Wird ausgelöst, wenn jemand Sie zum Verbinden einlädt.",
    contact_accept_description: "Benachrichtigt, wenn jemand Ihre Kontaktanfrage annimmt.",
    activation_required: "Aktivierung erforderlich",
  },
  hr: {
    language: "Postavke jezika",
    notifications: "Postavke obavijesti",
    privacy: "Postavke privatnosti",
    about: "O nama",
    terms: "Uvjeti i odredbe",
    select_language: "Odaberite jezik",
    language_description: "Odaberite željeni jezik za korisničko sučelje aplikacije.",
    current_language: "Trenutni jezik",
    language_code: "Kod jezika",
    language_tip: "Promjene jezika odmah se primjenjuju na sve prevedene stranice.",
    countries: "Države",
    select_countries: "Odaberite države",
    regions: "Regije",
    select_regions: "Odaberite regije",
    notification_type: "Vrsta obavijesti",
    email_notification: "E-mail obavijest",
    push_notification: "Push obavijest",
    save_notifications: "Spremi postavke obavijesti",
    settings_title: "Postavke",
    settings_description: "Upravljajte postavkama svog računa i aplikacije.",
    under_development: "Ovaj odjeljak je u izradi",
    link_account: "Poveži račun",
    link_account_description: "Možete povezati svoj Stripe račun s drugim uslugama za sinkronizaciju podataka o plaćanju na različitim platformama i upravljanje transakcijama.",
    stripe_account: "Stripe račun",
    stripe_connected: "Povezano",
    stripe_verification_pending: "Verifikacija na čekanju",
    stripe_data_shared: "Podaci se dijele sa Stripea na Hoowlr.",
    stripe_review_data: "Posjetite svoj Stripe račun kako biste pregledali koji se podaci dijele s Hoowlrom.",
    stripe_privacy_policy: "Stripe pravila privatnosti",
    stripe_linked_on: "Povezano {{date}}",
    update_details: "Ažuriraj detalje",
    unlink: "Prekini vezu",
    unlink_stripe_title: "Prekinuti vezu sa Stripeom?",
    unlink_stripe_description: "Morat ćete ponovno povezati Stripe za slanje ili primanje plaćanja. Prekid veze nije moguć dok imate aktivan dogovor ili aktivnu karticu prilike.",
    stripe_unlinked: "Veza sa Stripeom je prekinuta",
    failed_to_unlink_stripe: "Nije moguće prekinuti vezu sa Stripeom",
    failed_to_open_onboarding: "Otvaranje onboardinga nije uspjelo",
    validation_failed: "Provjera valjanosti nije uspjela",
    missing_profile_setting_id: "Nedostaje ID postavke profila",
    language_update_success: "Jezik je uspješno ažuriran",
    language_update_failed: "Ažuriranje jezika nije uspjelo",
    notifications_save_success: "Postavke obavijesti uspješno spremljene",
    notifications_save_failed: "Spremanje postavki nije uspjelo",
    failed_load_countries: "Učitavanje država nije uspjelo",
    failed_load_regions: "Učitavanje regija nije uspjelo",
    at_least_one_country: "Potrebna je barem jedna država",
    at_least_one_region: "Potrebna je barem jedna regija",
    card_publish_description: "Pokreće se kada se kartica objavi.",
    deal_propose_description: "Obavještava kada se predloži posao.",
    deal_confirm_description: "Obavještava kada je posao potvrđen.",
    contact_invite_description: "Pokreće se kada vas netko pozove na povezivanje.",
    contact_accept_description: "Obavještava kada netko prihvati vaš zahtjev za kontakt.",
    activation_required: "Potrebna je aktivacija", 
  },
};